import styled from "@emotion/styled";
import React from "react";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import { ServiceList } from "./ServiceList";
import { Info } from "../styled/texts";
import { ActionButton } from "../common/ActionButton";
import { useSearchParams } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  padding: 20px 30px;
`;

const ServiceCount = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #00256e;
  font-family: DM Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: rgba(20, 79, 195, 0.2);
  padding: 7px 15px;
  border-radius: 8px;
`;

const BigNumber = styled.div`
  color: #00256e;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const Services = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <Container>
      <Info>
        Below are the services provided by your business. You can view, edit and
        add your services here.
      </Info>
      <VerticalGap size={"30px"} />
      <ServiceCount>
        <BigNumber>12 </BigNumber>
        <HorizontalGap size={"5px"}></HorizontalGap>
        <span>services</span>
      </ServiceCount>
      <VerticalGap size={"20px"} />
      <ActionButton
        label={"Add New Service"}
        clickHandler={() => {
          setSearchParams({
            dialog: "open",
            for: "services",
            action: "add",
          });
        }}
      />
      <VerticalGap size={"20px"} />
      <ServiceList />
    </Container>
  );
};

export { Services };
